// ── Garancia – EGYETLEN forrás a szövegekhez (audit 2026-10-26, #10) ─────────
//
// Két KÜLÖN vállalás, amit korábban az oldalak keverték („6 hónap
// szervizgarancia" a használt telefonok mellett is megjelent):
//   - javításra:        6 hónap szervizgarancia
//   - használt telefonra: 3 hónap szervizgarancia
// Mindig EGYBEÍRVA: szervizgarancia. Az ÁSZF-ben rögzített feltételeken ez
// nem változtat, csak a megfogalmazást egységesíti.

export const GARANCIA_JAVITAS = '6 hónap szervizgarancia minden javításra';
export const GARANCIA_HASZNALT = '3 hónap szervizgarancia minden általunk eladott használt készülékre';
/** Rövid címke (kártya, lista) – a használt készülékekhez. */
export const GARANCIA_HASZNALT_ROVID = '3 hónap szervizgarancia';
